function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Validate that obj is an ISolidStrokeModel
 * @param obj
 */
export function isISolidStrokeModel(obj) {
  return _typeof(obj) === 'object' && obj.width != null && obj.color != null;
}